exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inlet-wrapp table.csas-table td:not(:first-child) {\n  text-align: center;\n  min-width: 170px;\n}\n.inlet-wrapp table.csas-table tbody td {\n  padding: 6px !important;\n}\n.inlet-wrapp table.csas-table td div.czk {\n  display: inline;\n  padding-left: 5px;\n}\n\n@media screen and (min-width: 970px) {\n  .inlet-wrapp table.csas-table {\n    font-size: 1em;\n  }\n}\n@media screen and (max-width: 969px) {\n  .inlet-wrapp .csas-sticked-table {\n    max-width: 100%;\n    font-size: 1em;\n  }\n}\n", ""]);

// exports
